import { BettingTypeGroup } from "@gp/models";

export const ALL_BETTING_TYPE_GROUP: BettingTypeGroup = {
    name: "BETTING_TYPE_GROUPS.ALL",
    abrv: "all",
    sortOrder: -3,
    id: "all"
};

export const BET_BUILDER_BETTING_TYPE_GROUP: BettingTypeGroup = {
    name: "BETTING_TYPE_GROUPS.BET_BUILDER",
    abrv: "betBuilder",
    sortOrder: -2,
    id: "betBuilder"
};

export const FAVORITE_BETTING_TYPE_GROUP: BettingTypeGroup = {
    name: "BETTING_TYPE_GROUPS.FAVORITES",
    abrv: "favorites",
    sortOrder: -1,
    id: "favorites"
}